import { debounce, get } from "lodash";
import { useEffect } from "react";

import {
  useGetInformationSystemsLazyQuery,
  useGetLevelsLazyQuery,
} from "~/schemas/generated/graphql";

export const useGetAllInfoSystemsForSelect = () => {
  const [getInfoSystems, { data, loading, fetchMore }] =
    useGetInformationSystemsLazyQuery({
      variables: {
        page: 0,
        count: 25,
      },
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
    });

  useEffect(() => {
    getInfoSystems();
  }, []);

  const infoSystems = data?.PositionGetter?.getInformationSystems?.items.map(
    ({ id, name }) => {
      return {
        value: id,
        label: `${name}`,
      };
    },
  );

  const intersectionObserver = () => {
    if (infoSystems.length < 25) {
      return;
    }
    const page = Math.ceil(infoSystems.length / 25);
    fetchMore({
      variables: {
        page,
        count: 25,
      },
      updateQuery: ({ PositionGetter }, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return { PositionGetter };
        }
        return {
          PositionGetter: {
            ...PositionGetter,
            getInformationSystems: {
              ...PositionGetter.getInformationSystems,
              items: [
                ...PositionGetter.getInformationSystems.items,
                ...get(
                  fetchMoreResult,
                  "PositionGetter.getInformationSystems.items",
                  [],
                ),
              ],
            },
          },
        };
      },
    });
  };

  const searchText = debounce((searchText: string) => {
    getInfoSystems({
      variables: {
        page: 0,
        name: searchText || null,
      },
    });
  });

  return {
    infoSystems,
    intersectionObserver,
    searchText,
    loading,
  };
};
